import { render, staticRenderFns } from "./showModel.vue?vue&type=template&id=7bd558cc&scoped=true&"
import script from "./showModel.vue?vue&type=script&lang=js&"
export * from "./showModel.vue?vue&type=script&lang=js&"
import style0 from "./showModel.vue?vue&type=style&index=0&id=7bd558cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd558cc",
  null
  
)

export default component.exports